import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("tb_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("tb_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const applyAuth = (data) => {
    localStorage.setItem("tb_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    return applyAuth(res.data);
  };

  const register = async (payload) => {
    const res = await api.post("/auth/register", payload);
    return applyAuth(res.data);
  };

  const logout = () => {
    localStorage.removeItem("tb_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
